import styles from "../Profile/Profile.module.css";

import backButton from "../../assests/popup/backButton.svg";
import shareButton from "../../assests/shareWithoutBg.svg";
import user from "../../assests/user.svg";
import loadingAnimation from "../../assests/loading.json";
import Backbutton from "../Assets/Back.svg";
import trophy from "../../assests/trophy.png";
import vsIcon from "../../assests/vsIcon.svg";
import DeleteModel from "./DeleteModel";
import SharePopup from "../SharePopup/SharePopup";
import { useState, useEffect, useContext } from "react";
import { useLocation, useNavigate, useParams } from "react-router";
import Carousel from "../Carousel/Carousel";
import deleteButton from "../../assests/popup/delete.svg";
import axios from "axios";
import { useUserAuth } from "../../context/UserAuthContext";
import ContactUsFooter from "../ContactUsFooter/ContactUsFooter";
import Context from "../../context/Context";
import Lottie from "react-lottie-player";
import { flatMap, isEmpty } from "lodash";
import GiftClaimPopup from "../GiftClaimPopup/GiftClaimPopup";
import ProfilePortal from "../../Layout/ProfilePortal";
import useGetUserProfileImage from "../../hooks/useGetUserProfileImage";
import CoverPhotoUpdate from "../CoverPhotoUpdate/CoverPhotoUpdate";
import MessagePopup from "../MessagePopup/MessagePopup";
import successTick from "../../assests/successTick.svg";
import ReactPlayer from "react-player";
import prediction from "../../assests/Prediction.png";

import AudioPlayerWithoutDownload from "../AudioPlayerWithoutDownload/AudioPlayerWithoutDownload";
import LoadingFromCenter from "../LoadingFromCenter/LoadingFromCenter";

function ProfilePopup({
  setShowPreview,
  singleFileDetails,
  token,
  profileContent,
  type,
  singleFileLoading,
  setSingleFileDetails,
}) {
  const [showDelete, setShowDelete] = useState(false);
  const [share, setShare] = useState(false);
  const [showShare, setShowShare] = useState(true);
  const navigate = useNavigate();
  const { currentUser, newUserId } = useUserAuth();
  const { campaignMetaData, loadHomePageDetails, isMobile } =
    useContext(Context);
  const [contestMetaData, setContestMetaData] = useState({});
  const [giftClaimPopup, setGiftClaimPopup] = useState(false);
  const [coverPhotoUpdatePopup, setCoverPhotoUpdatePopup] = useState(false);
  const [updateSuccess, setUpdateSuccess] = useState(false);
  const [metaDataLoading, setMetaDataLoading] = useState(false);
  const location = useLocation();
  const userId = localStorage.getItem("userId");
  let userIdFromLocalOrApi = newUserId || userId;
  useEffect(() => {
    if (singleFileDetails?.status === "EDITED") {
      setShowShare(false);
    } else {
      setShowShare(true);
    }
  });

  function ShareHandle() {
    if (isMobile) {
      let copyText = "";
      if (userIdFromLocalOrApi) {
        copyText =
          "https://share.goviralit.com" +
          "/vidu" +
          userIdFromLocalOrApi +
          "o" +
          singleFileDetails?.orgId +
          "cp" +
          singleFileDetails?.campaignId +
          "cn" +
          singleFileDetails?.contestId +
          "e" +
          singleFileDetails?._id;
      } else {
        copyText =
          "https://share.goviralit.com" +
          "/vid" +
          "o" +
          singleFileDetails?.orgId +
          "cp" +
          singleFileDetails?.campaignId +
          "cn" +
          singleFileDetails?.contestId +
          "e" +
          singleFileDetails?._id;
      }
      if (window.messageHandler) {
        window.messageHandler.postMessage(
          JSON.stringify({
            url: copyText,
            imageUrl: singleFileDetails?.qrCodeUrl,
          })
        );
      } else {
        alert("Flutter messageHandler not found!");
      }
      return;
    }
    setShare(share ? false : true);
  }
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "unset";
    };
  }, []);
  const [data, setData] = useState();

  useEffect(() => {
    if (!isEmpty(singleFileDetails)) {
      loadFormAttributes();
      loadContestDetails();
    }
  }, [singleFileDetails?._id]);
  const loadFormAttributes = async () => {
    try {
      const data = await axios.get(
        `${process.env.REACT_APP_FORM_ATTRIBUTES}/${singleFileDetails?.orgId}/${singleFileDetails?.campaignId}/${singleFileDetails?.contestId}/formAttributes.json`
      );
      setData(data?.data);
    } catch (error) {
      console.log(error.message);
      //navigate("/error")
    }
  };
  const loadContestDetails = async () => {
    setMetaDataLoading(true);
    try {
      const data = await axios.get(
        `${process.env.REACT_APP_CONTEST_PRICE_DETAILS}/${singleFileDetails?.orgId}/${singleFileDetails?.campaignId}/${singleFileDetails?.contestId}/metaData.json`
      );
      setContestMetaData(data?.data);
      setMetaDataLoading(false);
    } catch (error) {
      console.log(error.message);
      setMetaDataLoading(false);
      //navigate("/error")
    }
  };
  const profileHelpNavigate = () => {
    window.open(`/profile/help`);
  };
  const { profilePicture } = useGetUserProfileImage(singleFileDetails);

  const coverUpdateMessage =
    "Cover photo updated successfully; it will be visible shortly.";

  const handleViewLike = (e) => {
    if (singleFileDetails?.uid == currentUser?.uid) {
      navigate(
        `/${singleFileDetails?.orgDomain}/${singleFileDetails?.campaignUniqueText}/${singleFileDetails?.contestUniqueText}/${singleFileDetails?._id}/likes`,
        { state: { previousLocation: location?.pathname } }
      );
    }
  };
  const handleOpenContest = () => {
    loadHomePageDetails(
      singleFileDetails?.orgDomain,
      singleFileDetails?.campaignUniqueText
    );
    navigate(
      `/${singleFileDetails?.orgDomain}/${singleFileDetails?.campaignUniqueText}/${singleFileDetails?.contestUniqueText}`
    );
  };

  return (
    <ProfilePortal>
      <div className={styles.profilePopup} id="portal-profile">
        {singleFileLoading ? (
          <div className="w-[100%] h-[100vh] flex items-center justify-center">
            <Lottie
              loop
              animationData={loadingAnimation}
              play
              style={{ width: 173, height: 173 }}
            />
          </div>
        ) : (
          <div className="h-[100vh] w-[100%] max-w-[600px] bg-[#000000] relative no-scrollbar overflow-y-scroll pb-[60px]">
            <div className={styles.header}>
              <div className={styles.headerInnerPill}>
                <img
                  src={backButton}
                  alt=""
                  className={` dismissButton ${styles.backButton}`}
                  onClick={() => setShowPreview(false)}
                />
                <div
                  className="z-[1] w-[100%] cursor-pointer"
                  onClick={handleOpenContest}
                >
                  <p className="text-regular text_1Line text-center">
                    {/* {singleFileDetails?.campaignName}
                {" - "} */}
                    <span style={{ color: singleFileDetails?.buttonColor }}>
                      {" "}
                      {singleFileDetails?.contestName}
                    </span>
                  </p>
                </div>
                <div className="w-[32px] h-[32px]" />
              </div>
            </div>

            <div className="flex justify-between items-center w-[100%] gap-[15px] py-[16px] px-[20px]">
              <div className="flex items-center justify-center gap-[10px] select-none z-[1]">
                {type == "winner" && (
                  <img
                    src={profilePicture || user}
                    alt=""
                    className="h-[40px] w-[40px] rounded-full overflow-hidden  object-cover"
                  />
                )}

                {type != "demo" && type != "winner" && (
                  <img
                    src={currentUser?.photoURL ? currentUser?.photoURL : user}
                    alt=""
                    className="h-[40px] w-[40px] rounded-full overflow-hidden  object-cover"
                  />
                )}
                <p className="text-regular">
                  {singleFileDetails?.participantName}
                </p>
              </div>
              {currentUser?.uid == singleFileDetails?.uid &&
                singleFileDetails?.status != "USER_REMOVED" && (
                  <p
                    onClick={() => setShowDelete(true)}
                    className="text-regular text-[#FA6B6B] cursor-pointer"
                  >
                    Delete
                  </p>
                )}
            </div>
            <div
              className="w-[100%] h-[50%]"
              style={{
                background: `url(${
                  singleFileDetails?.fileUrls &&
                  singleFileDetails?.fileUrls[0] &&
                  singleFileDetails?.fileUrls[0].fileUrl
                }) center center/cover no-repeat`,
              }}
            >
              <div className={styles.imageBg}>
                {!singleFileDetails?.fileType?.startsWith("audio") && (
                  <Carousel items={singleFileDetails?.fileUrls} />
                )}

                {singleFileDetails?.fileType?.startsWith("audio") && (
                  <div className="h-full p-[20px] ">
                    <img
                      src={singleFileDetails?.thumbnailUrl}
                      className={`h-[80%] w-[100%] mx-auto object-contain mb-[10px]`}
                    />
                    <AudioPlayerWithoutDownload
                      fileUrl={
                        singleFileDetails?.fileUrls &&
                        singleFileDetails?.fileUrls[0] &&
                        singleFileDetails?.fileUrls[0].fileUrl
                      }
                      fileName="my voice recording"
                    />
                  </div>
                )}
              </div>
            </div>
            {singleFileDetails?.status === "EDITED" && (
              <div className=" px-[20px] mt-[16px]">
                <p className="text-small-bold text-black bg-[#FFFFFD] w-[100%] py-[10px] text-center rounded-[6px]">
                  Under Review
                </p>
              </div>
            )}
            {/* {singleFileDetails?.status === "ADMIN_PUBLISHED" && ( */}
            <>
              <div className="py-[16px] px-[20px] flex justify-between items-center">
                <div className="flex flex-col">
                  <p
                    className={`whitespace-nowrap ${
                      singleFileDetails?.uid == currentUser?.uid
                        ? styles.clickable
                        : ""
                    }`}
                    onClick={handleViewLike}
                  >
                    {singleFileDetails?.likesCount} Votes
                  </p>
                </div>
                <button>
                  {currentUser?.uid == singleFileDetails?.uid &&
                    singleFileDetails?.fileType.startsWith("video") &&
                    singleFileDetails?.defaultThumbnail && (
                      <p
                        onClick={() => setCoverPhotoUpdatePopup(true)}
                        className="commonButton"
                        style={{
                          background:
                            singleFileDetails?.buttonColor || "#FA6B6B",
                        }}
                      >
                        Update Cover Photo
                      </p>
                    )}
                </button>

                <img
                  src={shareButton}
                  alt=""
                  className="w-[36px] h-[36px] hover:cursor-pointer  z-[1]"
                  onClick={ShareHandle}
                />
              </div>
              {metaDataLoading ? (
                <div className="px-[20px]">
                  <LoadingFromCenter />
                </div>
              ) : (
                currentUser?.uid == singleFileDetails?.uid &&
                (singleFileDetails?.winner || contestMetaData?.giftforAll) && (
                  <div className="pb-[16px] px-[16px] flex items-start justify-between gap-[10px]">
                    <p>
                      {singleFileDetails?.winnerObject?.text ||
                        contestMetaData?.giftforAllText}
                    </p>

                    {contestMetaData?.claimingClosed ? (
                      <button className="drop-shadow px-[12px] py-[5px] bg-[#262626] text-[#f6f6f6] rounded-[10px] text-regular">
                        Claiming Closed
                      </button>
                    ) : (
                      <button
                        className="drop-shadow px-[12px] py-[5px] bg-[#262626] text-[#f6f6f6] rounded-[10px] text-regular"
                        onClick={() => setGiftClaimPopup(true)}
                        disabled={
                          singleFileDetails?.giftClaimStatus ==
                            "ADDRESS_UPDATED" ||
                          singleFileDetails?.giftClaimStatus ==
                            "GIFT_CLAIMED" ||
                          singleFileDetails?.giftClaimStatus == "GIFT_SENTED"
                        }
                      >
                        {singleFileDetails?.giftClaimStatus ==
                          "ADDRESS_UPDATED" && "Submitted"}
                        {singleFileDetails?.giftClaimStatus == "GIFT_SENTED" &&
                          "Submitted"}
                        {singleFileDetails?.giftClaimStatus == "GIFT_CLAIMED" &&
                          "Claimed"}
                        {singleFileDetails?.giftClaimStatus !==
                          "GIFT_CLAIMED" &&
                          singleFileDetails?.giftClaimStatus !==
                            "ADDRESS_UPDATED" &&
                          singleFileDetails?.giftClaimStatus !==
                            "GIFT_SENTED" &&
                          "Claim"}
                      </button>
                    )}
                  </div>
                )
              )}

              {singleFileDetails?.description && (
                <div className="px-[20px]">
                  <div className="seperator" />
                </div>
              )}
            </>
            {/* )} */}
            <div className="p-[16px]">
              {!isEmpty(singleFileDetails?.predictions) && (
                <div>
                  <p
                    className="text-regular-medium mb-[12px]"
                    style={{
                      color: contestMetaData?.buttonColor,
                    }}
                  >
                    Predictions
                  </p>
                  {singleFileDetails?.predictions?.map((obj) => {
                    const matchDetails = contestMetaData?.matchDetails?.find(
                      (el) => el?.id == obj?.id
                    );
                    const matchDate = new Date(matchDetails?.matchDate);
                    const formattedMatchDate = `${matchDate.toLocaleString(
                      "default",
                      {
                        month: "long",
                      }
                    )} ${matchDate.getUTCDate()} ${matchDate.getUTCFullYear()} , ${matchDate.toLocaleTimeString()}`;

                    return (
                      <div className="p-[15px] mb-[20px] rounded-[20px] bg-[#141414]">
                        <div className="flex items-center gap-[6px] pb-[16px] border-b-[1px] border-[#363636]">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="18"
                            viewBox="0 0 18 18"
                            fill="none"
                          >
                            <path
                              d="M8.66137 2.649C8.69235 2.58558 8.74052 2.53214 8.80039 2.49476C8.86026 2.45738 8.92942 2.43756 9 2.43756C9.07058 2.43756 9.13974 2.45738 9.19961 2.49476C9.25947 2.53214 9.30764 2.58558 9.33862 2.649L11.1319 6.3C11.187 6.41175 11.2931 6.48938 11.4165 6.50738L15.4264 7.09275C15.7361 7.13812 15.8595 7.52062 15.6356 7.74L12.7339 10.5821C12.6899 10.625 12.657 10.678 12.638 10.7365C12.6191 10.795 12.6147 10.8572 12.6251 10.9178L13.3102 14.9303C13.3631 15.2404 13.0395 15.477 12.7624 15.3307L9.17587 13.4359C9.12171 13.4071 9.06132 13.3921 9 13.3921C8.93867 13.3921 8.87828 13.4071 8.82412 13.4359L5.23762 15.3307C4.9605 15.477 4.63687 15.2407 4.68975 14.9306L5.3745 10.9181C5.38503 10.8575 5.38063 10.7952 5.36168 10.7367C5.34273 10.6781 5.30981 10.6251 5.26575 10.5821L2.36475 7.74C2.1405 7.52062 2.26425 7.13812 2.574 7.09275L6.58425 6.50775C6.70725 6.48938 6.81337 6.41175 6.8685 6.3L8.66137 2.649Z"
                              fill="#FFE100"
                            />
                          </svg>
                          <p className="text-small-medium ">
                            Match Day:{" "}
                            {matchDate == "Invalid Date"
                              ? matchDetails?.matchDate
                              : formattedMatchDate}
                          </p>
                        </div>

                        <div className=" w-full">
                          <div className="my-[18px] flex w-[100%] gap-[17px] justify-evenly items-center">
                            <div
                              className={`flex flex-col items-center cursor-pointer p-[10px] rounded-[10px] relative w-full ${
                                matchDetails?.winner == "team1" &&
                                "border-[1px] border-[#FFA82833]"
                              }`}
                            >
                              {matchDetails?.winner == "team1" && (
                                <img
                                  src={trophy}
                                  className="absolute top-[-10px] mx-auto"
                                />
                              )}
                              <div className="w-[62px] h-[62px] rounded-[8px] overflow-hidden bg-white">
                                <img src={matchDetails?.team1?.logo} alt="" />
                              </div>
                              <p className="text-white mt-[12px] text-center text-small-medium">
                                {matchDetails?.team1?.name}
                              </p>
                            </div>
                            <img src={vsIcon} className="" />

                            <div
                              className={`flex flex-col items-center cursor-pointer p-[10px] rounded-[10px] relative w-full ${
                                matchDetails?.winner == "team2" &&
                                "border-[1px] border-[#FFA82833]"
                              }`}
                            >
                              {matchDetails?.winner == "team2" && (
                                <img
                                  src={trophy}
                                  className="absolute top-[-10px] mx-auto"
                                />
                              )}
                              <div className="w-[62px] h-[62px] rounded-[8px] overflow-hidden bg-white">
                                <img src={matchDetails?.team2?.logo} alt="" />
                              </div>
                              <p className="text-white mt-[12px] text-center text-small-medium">
                                {matchDetails?.team2.name}
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="flex w-full items-center gap-[16px] pt-[16px] border-t-[1px] border-[#363636]">
                          <img src={prediction} className="h-[12px]" />

                          <p className="text-small-medium">
                            {matchDetails &&
                              matchDetails[obj.prediction] &&
                              matchDetails[obj.prediction].name}
                          </p>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
              {singleFileDetails?.description && (
                <div
                  className={`text-regular mb-[20px] bg-[#0f0f0f] text-[#f6f6f6] rounded-[10px] py-[16px] px-[10px]`}
                >
                  <p>{singleFileDetails?.description}</p>
                </div>
              )}
              {data?.formAttributes?.map((el) => {
                return (
                  <div className="flex flex-col gap-[30px] px-[4px]">
                    {el?.items?.map((key) => {
                      if (singleFileDetails[key] && el?.display) {
                        if (el.attrType == "media") {
                          return (
                            <div className="pb-[30px]">
                              <p
                                className="text-regular-medium mb-[12px]"
                                style={{
                                  color: singleFileDetails?.buttonColor
                                    ? singleFileDetails?.buttonColor
                                    : "#FFE100",
                                }}
                              >
                                {el?.title}{" "}
                              </p>
                              {el?.type?.startsWith("image") && (
                                <div className=" h-[160px] overflow-hidden flex items-center justify-center mb-[5px] rounded-[5px] bg-[#1c1c1c] px-[15px] py-[18px]">
                                  <img
                                    src={singleFileDetails[key]}
                                    className="w-auto h-[100%]"
                                  />
                                </div>
                              )}
                              {el?.type?.startsWith("video") && (
                                <div className="h-[320px] w-[100%] overflow-hidden flex items-center justify-center mb-[15px] bg-[#1c1c1c]">
                                  <ReactPlayer
                                    playing={false}
                                    controls={true}
                                    width="100%"
                                    height="100%"
                                    url={singleFileDetails[key]}
                                    style={{ objectFit: "contain" }}
                                  />
                                </div>
                              )}
                            </div>
                          );
                        } else {
                          return (
                            <div className="pb-[30px]">
                              <p
                                className="text-regular-medium mb-[12px]"
                                style={{
                                  color: singleFileDetails?.buttonColor
                                    ? singleFileDetails?.buttonColor
                                    : "#FFE100",
                                }}
                              >
                                {el?.title}{" "}
                              </p>
                              <p className="text-regular-callout  text-[#606060]">
                                {singleFileDetails[key]}
                              </p>
                            </div>
                          );
                        }
                      }
                    })}
                  </div>
                );
              })}
            </div>
            <div className="px-[20px] mt-[40px] ">
              <div className="seperator " />
            </div>
            <ContactUsFooter profileHelpNavigate={profileHelpNavigate} />
            <div>
              {showDelete && (
                <DeleteModel
                  setShowDelete={setShowDelete}
                  singleFileDetails={singleFileDetails}
                  token={token}
                  profileContent={profileContent}
                  setShowPreview={setShowPreview}
                />
              )}
            </div>
            {share && (
              <div>
                <div className="absolute h-[100%] w-[100%] flex items-center justify-center top-[-10px]">
                  <SharePopup
                    showShare={ShareHandle}
                    contestant={singleFileDetails}
                  />
                </div>
              </div>
            )}
            {giftClaimPopup && (
              <GiftClaimPopup
                setPopup={setGiftClaimPopup}
                claimOptions={contestMetaData?.claimOptions}
                data={singleFileDetails}
                setSingleFileDetails={setSingleFileDetails}
                contestMetaData={contestMetaData}
              />
            )}
            {coverPhotoUpdatePopup && (
              <CoverPhotoUpdate
                setPopup={setCoverPhotoUpdatePopup}
                data={singleFileDetails}
                setUpdateSuccess={setUpdateSuccess}
              />
            )}
            {updateSuccess && (
              <MessagePopup
                logo={successTick}
                setPopup={setUpdateSuccess}
                backgroundColor={singleFileDetails?.buttonColor}
                message={coverUpdateMessage}
              />
            )}
          </div>
        )}
      </div>
    </ProfilePortal>
  );
}

export default ProfilePopup;
